import { send } from 'server';

export const changeFavorite = ({ code, isFavorite }) => send({
    ID: 31106,
    requestType: isFavorite ? 'add' : 'remove',
    description: 'Change Player Favorites Games',
    gameTypes: [code],
    responses: [31107, 31108]
});
